<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">Again, to acknowledge my sister, Marina, who is now my manager for all that she did and still does for me. Her support and belief in<br/>
me are outstanding.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?698053fc